import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Search} from 'lucide-react';
import UserProfile from './UserProfile';
import { useAuth } from '../contexts/AuthContext';

const Layout = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const isChatPage = location.pathname === '/chat';

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/dashboard/reports?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // const isActive = (path) => {
  //   return location.pathname === path;
  // };

  return (
    <div className={`min-h-screen bg-n1 ${isChatPage ? 'h-screen overflow-hidden flex flex-col' : ''}`}>
      {/* Header - Carbon Black band with the gold accent rule beneath it */}
      <header className="bg-sandvik-black border-b-4 border-gold flex-shrink-0">
        <div className="w-full flex items-center justify-between px-6 py-4" style={{height: '4rem'}}>
          {/* Left Side - Logo */}
          <div className="flex items-center space-x-3 cursor-pointer group flex-shrink-0" onClick={() => navigate('/')}>
            <img
              src="/sandvik_logotype_white_rgb.svg"
              alt="Sandvik"
              className="h-7 w-auto object-contain flex-shrink-0"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            {/* Fallback mark, shown only if the logotype fails to load */}
            <div className="w-10 h-10 bg-sandvik-black flex items-center justify-center text-white text-lg hidden">
              S
            </div>
            {/* <span className="text-2xl text-gray-900 tracking-tight">SANDVIK</span> */}
          </div>

          {/* Center - Navigation */}
          {/* <nav className="flex items-center space-x-8 flex-1 justify-center">
            <button
              onClick={() => navigate('/dashboard')}
              className={`px-4 py-2 transition-all duration-200 ${
                location.pathname === '/' || location.pathname.startsWith('/dashboard')
                  ? 'text-white bg-electric-blue shadow-sm' 
                  : 'text-gray-700 hover:text-black hover:bg-gray-100'
              }`}
            >
              Reports
            </button>
          </nav> */}

          {/* Right Side - Search and User Profile */}
          <div className="flex items-center space-x-4 flex-shrink-0">
            {/* Search Bar */}
            <div className="relative">
              <input
                type="text"
                placeholder="Search reports..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={handleKeyPress}
                className="w-80 pl-4 pr-12 py-2.5 bg-white text-sandvik-black placeholder-n5 border border-n3 focus:outline-none focus:ring-2 focus:ring-electric-blue focus:border-electric-blue transition-all duration-200"
              />
              <button
                onClick={handleSearch}
                aria-label="Search reports"
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-electric-blue text-white p-2 hover:bg-electric-blue-eb3 transition-colors duration-200"
              >
                <Search className="h-4 w-4" />
              </button>
            </div>
            
            {/* User Profile */}
            {isAuthenticated && <UserProfile />}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className={isChatPage ? 'flex-1 overflow-hidden' : ''}>
        <Outlet />
      </main>
      
    </div>
  );
};

export default Layout;